export const UPLOAD_VIDEOS_BASE_PATH = '/digital-marketing/upload-videos';

export const buildUploadVideosPath = (subPath = '') => {
    const normalizedSubPath = subPath.replace(/^\/+/, '');

    return normalizedSubPath
        ? `${UPLOAD_VIDEOS_BASE_PATH}/${normalizedSubPath}`
        : UPLOAD_VIDEOS_BASE_PATH;
};
